import OverviewActionTypes from '../actionTypes/overview.actionTypes'
import { ActionType } from './common.reducer'
import {
    OverviewWidgetResponse_FieldGroup,
    OverviewWidgetResponse_IndexComponent
} from '../proto/generated/overview-widget'

interface SecurityOverviewStateType {
    loading: boolean,
    fieldGroups: OverviewWidgetResponse_FieldGroup[]
    indexComponents: OverviewWidgetResponse_IndexComponent[]
    overviewSecurityKey: string | null
}

const initialState: SecurityOverviewStateType = {
    loading: false,
    fieldGroups: [],
    indexComponents: [],
    overviewSecurityKey: null
}

export default function overviewReducer(state = initialState, action: ActionType) {
    const { type, payload } = action

    switch (type) {
        case OverviewActionTypes.SET_LOADING:
            return {
                ...state,
                loading: payload
            }

        case OverviewActionTypes.SET_FIELD_GROUP:
            return {
                ...state,
                fieldGroups: payload
            }
        case OverviewActionTypes.SAVE_INDEX_COMPONENTS:
            return {
                ...state,
                indexComponents: payload
            }
        case OverviewActionTypes.SET_OVERVIEW_DATA:
            return {
                ...state,
                overviewSecurityKey: payload.securityKey,
                fieldGroups: payload.fieldGroups,
                indexComponents: payload.indexComponents
            }
        case OverviewActionTypes.CLEAR_OVERVIEW:
            return initialState
        default:
            return state
    }
}
